/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_NoteInputs */

const en_cp_form_note = /** @type {(inputs: Cp_Form_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short context: course/competition, number of students, goal`)
};

const id_cp_form_note = /** @type {(inputs: Cp_Form_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konteks singkat: mata kuliah/kompetisi, jumlah mahasiswa, target`)
};

/**
* | output |
* | --- |
* | "Short context: course/competition, number of students, goal" |
*
* @param {Cp_Form_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_note = /** @type {((inputs?: Cp_Form_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_note(inputs)
	return en_cp_form_note(inputs)
});